var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 187,
    viewBox: "0 0 183 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0432 30.424L146.175 52.018V120.734L81.3055 142.241L40.6528 85.9389L81.0432 30.424Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0431 30.4239L121.783 5.68263L88.7365 0L33.921 17.3976L23.3425 36.9808L81.0431 30.4239Z",
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.175 52.0179L121.783 5.68262L81.0432 30.4239L146.175 52.0179Z",
    fill: "#EAEAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6527 85.9389L23.3425 36.9808L81.0431 30.424L40.6527 85.9389Z",
    fill: "#AEAEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9209 17.3976L23.3425 36.9808L0 63.7329L33.9209 17.3976Z",
    fill: "#ABABAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6527 85.9389L23.4299 141.192L0.0874251 122.57L0 63.7329L23.3425 36.9808L40.6527 85.9389Z",
    fill: "#8F8F8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.175 52.0179L121.783 5.68262L143.202 18.4467L176.686 64.782L182.194 89.4359L146.175 52.0179Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.175 120.734L182.194 89.4359L146.175 52.0179V120.734Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3056 142.241L40.6529 85.9389L23.4302 141.192L81.3056 142.241Z",
    fill: "#868686"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0876465 122.57L34.0086 168.993L23.4302 141.192L0.0876465 122.57Z",
    fill: "#646464"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3056 142.241L23.4302 141.192L34.0086 168.993L88.9116 186.565L121.871 173.189L81.3056 142.241Z",
    fill: "#484848"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.175 120.734L81.3054 142.241L121.871 173.189L146.175 120.734Z",
    fill: "#868686"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.194 89.4359L146.175 120.734L121.87 173.189L143.115 168.73L176.424 122.483L182.194 89.4359Z",
    fill: "#C0C0C0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9114 186.565L121.871 173.189L143.115 168.73L88.9114 186.565Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/level1.83240fe2764458d23042e8eab87e9f98.svg";
export { ForwardRef as ReactComponent };